import { Head } from '@inertiajs/react'
import { Building2, ExternalLink } from 'lucide-react'
import PageHeader from './_components/PageHeader'
import OrganizationDetails from './_components/OrganizationDetails'
import StatsCards from './_components/StatsCards'
import UsersTable from './_components/UsersTable'
import { SalesminerOrganization } from "@/types/serializers";

interface Stats {
    users_count: number
    accounts_count: number
    opportunities_count: number
}

interface Props {
    organization: SalesminerOrganization
    stats: Stats
}

export default function Show({organization, stats}: Props) {

    return (
        <>
            <Head title={`${organization.name} - Organizations - Super Admin`}/>

            <div className="min-h-screen bg-gray-50">
                <PageHeader
                    title={organization.name!}
                    backUrl="/admin/organizations"
                    backText="← Back to Organizations"
                    icon={
                        organization.logo_url ? (
                            <img
                                src={organization.logo_url}
                                alt={`${organization.name} logo`}
                                className="h-8 w-8 rounded-full object-cover"
                            />
                        ) : (
                            <Building2 className="h-8 w-8 text-gray-400"/>
                        )
                    }
                    actions={
                        <a
                            href={`/~/${organization.slug}`}
                            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded text-sm font-medium transition-colors inline-flex items-center"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <ExternalLink className="w-4 h-4 mr-2"/>
                            View App
                        </a>
                    }
                />

                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <div className="px-4 py-6 sm:px-0 space-y-6">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <OrganizationDetails organization={organization}/>
                            <StatsCards stats={stats}/>
                        </div>

                        <UsersTable users={organization.users}/>
                    </div>
                </div>
            </div>
        </>
    )
}